import { Stack } from "@mui/material";
import { getReaction } from "./Reactions";
import Social from "../../services/API/Social";
import CommentIcon from '@mui/icons-material/ChatBubbleOutline';
import ReactIcon from '@mui/icons-material/ThumbUpOffAlt';
import SaveIcon from '@mui/icons-material/StarBorder';
import CloseIcon from '@mui/icons-material/Close';
import { useQueryClient, useMutation } from "react-query";
import { useTheme } from '@mui/material/styles';
import { txt } from "../../services/translation";

export default function Actions({post, onComment, onReact, showReactionForm, onReactionsFormClose, queryKey, page}){

    const queryClient = useQueryClient();

    /** Suppression optimiste de la réaction */
    const removeReaction = useMutation({

        mutationFn: () => Social.deleteReaction(post.id),

        onMutate: async () => {

            await queryClient.cancelQueries({ queryKey: queryKey })

            const previous = queryClient.getQueryData(queryKey)

            queryClient.setQueryData(queryKey, old => {

                const idx = old.pages[page - 1].data.findIndex(p => p.id === post.id);

                let newPost = {...post};
                newPost.reactionsSum.total--;
                newPost.reactionsSum[myReaction.class]--;
                newPost.myReaction = null;

                let copy = {...old};
                copy.pages[page - 1].data[idx] = newPost;

                return copy;
            })

            return { previous }
        },

        onError: (e, data, context) => {
            console.log(e, data)
            queryClient.setQueryData(queryKey, context.previous)
        },

        onSettled: () => {
            /** Commented for performance reasons */
            //queryClient.invalidateQueries({ queryKey: queryKey })
        },
    })


    /** Ajout ou suppression optimiste du favori */
    const toggleFavorite = useMutation({

        mutationFn: () => Social.toggleFavorite(post.id),

        onMutate: async () => {

            await queryClient.cancelQueries({ queryKey: queryKey })

            const previous = queryClient.getQueryData(queryKey)

            queryClient.setQueryData(queryKey, old => {

                const idx = old.pages[page - 1].data.findIndex(p => p.id === post.id);

                let newPost = {...post};
                newPost.favorite = !newPost.favorite;

                let copy = {...old};
                copy.pages[page - 1].data[idx] = newPost;

                return copy;
            })

            return { previous }
        },

        onError: (e, data, context) => {
            console.log(e, data)
            queryClient.setQueryData(queryKey, context.previous)
        },

        onSettled: () => {
            /** Commented for performance reasons */
            //queryClient.invalidateQueries({ queryKey: queryKey })
        },
    })


    let myReaction = post.myReaction ? getReaction(post.myReaction) : null;

    return <Stack direction='row'>

        {!myReaction ? 
            (!showReactionForm && <Action type='react' onClick={onReact} />)
            :
            <div className='social-post-action' onClick={() => removeReaction.mutate()}>
                {myReaction.icon}
                <span  className='social-post-action-text'>{myReaction.title}</span>
            </div>
        }

        {showReactionForm && !myReaction &&
            <Action type='cancel' onClick={onReactionsFormClose}/>
        }

        <Action type='comment' onClick={onComment}/>
        <Action type='save' active={post.favorite} onClick={() => toggleFavorite.mutate()} />
    </Stack>
}




function Action({type, onClick, active}){

    const theme = useTheme();

    const style = !active ? {} : {color: theme.palette.primary.main};

    const types = {
        react: { title: txt('reactTitle'), icon: <ReactIcon /> },
        comment: { title: txt('commentTitle'), icon: <CommentIcon /> },
        save: { title: txt('saveTitle'), icon: <SaveIcon color={active ? 'primary' : 'inherit'} /> },
        cancel: { title: txt('cancelTitle'), icon: <CloseIcon /> },
    };

    const action = types[type];

    return <div className='social-post-action' onClick={onClick}>
        {action.icon}
        <span className='social-post-action-text' style={style}>{action.title}</span>
    </div>
}
